import React, {useEffect, useState} from 'react';
import { Accordion, Toggle } from '../../../../components';
import {useCurrentUser} from "../../../../contexts/UserContext";
import { useViewerStore} from "../../../../store/store";
import {Badge, Button, Divider, Flex, Select, Tooltip,Radio, RadioChangeEvent} from 'antd';
import MoveModuleByMeasurement from "../../../../components/Layout-Components/Editor-Layout/Modal/Modal-Content/MoveModuleByMeasurement";
import ModuleEditOptionsSection from "./ModuleEditOptionsSection";
import {
    Angle,
    ArrowsClockwise, ArrowsCounterClockwise,
    ArrowsHorizontal, ArrowsOut,
    ArrowsVertical,
    BoundingBox,
    CheckCircle,
    Eraser, Flag, Plus, Question,
    Ruler
} from "@phosphor-icons/react";
import {MdOutlineCropLandscape, MdOutlineCropPortrait} from "react-icons/md";
import {BsGrid1X2} from "react-icons/bs";

import {
    SetDisplayShadePoints
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/RefreshShade";
import {
    addBallastedRackedModules,
    flipBallastTypeModule,
    GetSelModules,
    ResetSelModuleArr, SetModuleSize,
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/ModuleControl";
import TotalSystemEfficiency
    from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/TotalSystemEfficiency";
import RoofInformationTable
    from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/RoofInformationTable";
import { LAYER_OPTIONS } from '../../../../Constants';
import {
    OverrideSetbackDepthTo36, UpdateSetbackDepth
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/PathwayControl";
import {
    deActivateRoof, getRoofModuleMeshes, ifRoofDeactivated, reActivateRoof,
    updateRoofsAltered
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Common";
import { toggleLayer } from '../../../../helpers/storeHelpers';
import { moduleDir, ModuleMesh, RoofMesh } from '../../../../@types/types';
import {
    isGroundMount
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/PlaneRoofControls";
import ModuleTypeChangeConfirm
    from "../../../../components/Layout-Components/Editor-Layout/Modal/Modal-Content/ModuleTypeChangeConfirm";

const ModuleProperties: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const {hasCapability,user} = useCurrentUser();
    const manualZone = useViewerStore((state) => state.manualZone)
    const moduleList = useViewerStore((state) => state.moduleList);
    const isRoofTagVisible = useViewerStore((state) => state.isRoofTagVisible)
    const isSetbackOverride = useViewerStore((state) => state.isSetbackOverride)
    const activeModule = useViewerStore((state) => state.activeModule);
    const selectedRoof =  useViewerStore((state) => state.selRoofFaceArr);
    const [selectedRoofStatus, setSelectedRoofStatus] = useState(false);
    const refreshContextMenu = useViewerStore(state => state.refreshContextMenu)
    const moduleSolarAccess = useViewerStore(state => state.moduleSolarAccess);
    const isBallastedRackingMeeting25percentRule = useViewerStore((state) => state.isBallastedRackingMeeting25percentRule);
    const isBallastedRackTypeModuleActive = useViewerStore((state) => state.isBallastedRackTypeModuleActive);
    const isBallastedRackUpdated = useViewerStore((state) => state.isBallastedRackUpdated);
    const activeBallastRackDirection = useViewerStore((state) => state.activeBallastRackDirection);
    const doesDesignContainFlatRoof = useViewerStore(state => state.doesDesignContainFlatRoof);
    const selRoof = useViewerStore(state => state.selRoofFaceArr);
    const modeCount = useViewerStore(state => state.modeCount);
    const [showBallastRackAccordian, setShowBallastRackAccordian] = useState(false);

    const moduleListSorted = moduleList.filter(m => m.w !== 0 && m.h !== 0);
    moduleListSorted.sort((a, b) => a.text.localeCompare(b.text));

    const antdCompatiableModuleList = moduleListSorted.map(m => ({text: m.text, value: m.text}));

    const {selRoofFaceArr} = useViewerStore();
    const isBoxSelectMode = useViewerStore(state => state.isBoxSelectMode);

    useEffect(() => {
        sceneViewer?.hideObject('ModuleTexture', moduleSolarAccess);
    }, [sceneViewer, moduleSolarAccess]);




    const selectModule = (e: string) => {
        if (manualZone) return;
        const {moveMode} = sceneViewer;
        if (moveMode) return;

        const selModule: any = moduleList.find(item => item.text === e);
        if (selModule === -1) {
            return;
        }



        sceneViewer.viewerAlert({
            show: true,
            title: "Confirm Module Type Change",
            message: <ModuleTypeChangeConfirm selModule={selModule} />,
            messageType: "info",
            isModal: true
        })



    }

    const handleMoveModuleByMeasurement = () => {
        //check if module is selected
        //if not selected show alert
        const selModules = GetSelModules(sceneViewer.moduleMeshArr);
        if (!selModules || !selModules.length) {
            alert("Please select a module to move by measurement")
        } else {
            sceneViewer.viewerAlert({
                show: true,
                title: "Move Module by Measurement",
                message: <MoveModuleByMeasurement/>,
                messageType: "info",
                isModal: true
            })
        }
    }

    const setBoxSelectMode = () => {
        ResetSelModuleArr(sceneViewer.moduleMeshArr);
        if(isBoxSelectMode) {
            sceneViewer.removeSelectionBoxHelper();
        } else {
            sceneViewer.selectType = 'module';
            sceneViewer.setupSelectionBoxHelper('module');
        }
    }

    const toggleRoofTag = () => {
        sceneViewer.toggleRoofTag(!isRoofTagVisible);
        useViewerStore.setState({isRoofTagVisible: !isRoofTagVisible});
    }

    const spinAllModules = () => {
        sceneViewer.spinAllModules();
    }

    const clearModule = (selFace: RoofMesh) => {
        const {moduleCount, roofFaceId} = selFace;
        if (!moduleCount) return;
        sceneViewer.setClearFaceModule(selFace);
        const cloneFaceArr = [...selRoofFaceArr];
        cloneFaceArr.forEach(face => {
            if (face.roofFaceId === roofFaceId) face.moduleCount = 0;
        });
        useViewerStore.setState({selRoofFaceArr: cloneFaceArr});
    }

    const autoFillHandler = (direction: moduleDir) => {
        sceneViewer.setRoofModuleDir(direction);
    }

    const toggleSetbackOverride = () => {
        useViewerStore.setState({isSetbackOverride: !isSetbackOverride});
    }

    const deactivateRoofHandler = () => {
        const currentSelectedRoof = useViewerStore.getState().selRoofFaceArr[0];
        if (ifRoofDeactivated(currentSelectedRoof.userData.roof_tag_id)) {
            reActivateRoof(currentSelectedRoof)
        }
        else {
            deActivateRoof(currentSelectedRoof)
        }
    }

    useEffect(() => {

        if(!selRoofFaceArr || selRoofFaceArr.length === 0) return;

        const selectedRoofId = selectedRoof[0].userData.roof_tag_id;

        if(ifRoofDeactivated(selectedRoofId)){
            setSelectedRoofStatus(true)
        }
        else{
            setSelectedRoofStatus(false)
        }

    }, [selRoofFaceArr,refreshContextMenu])



    useEffect(()=>{
        if(isSetbackOverride){
            OverrideSetbackDepthTo36(sceneViewer)
        }
        else{
            if(modeCount > 0){
                UpdateSetbackDepth(sceneViewer,);
            }
        }

    },[isSetbackOverride,modeCount])

    const addBallastedRackModule = () => {
        addBallastedRackedModules()
    }


    const calculate25PercentBallastModules = () => {
        const nonBallastedModules = sceneViewer.moduleMeshArr.filter((item: ModuleMesh) => !item.userData.isBallastedRackType).length;
        //check if ballasted modules are 25% of non ballasted modules
        if (nonBallastedModules === 0) return "Min 10 Ballast modules required as No Regular modules added";

        return Math.round(nonBallastedModules * 0.25)
    }

    const rackingOptions = [
        {value: '10', text: '10°'},
    ]

    const rackingDirectionOptions = [
        {
            label: <><ArrowsHorizontal/> Horizontal</>,
            value: 'horizontal',
        },
        {
            label: <><ArrowsVertical/> Vertical</>,
            value: 'vertical',
        }
    ];

    const setRackDirection = (e: RadioChangeEvent) => {

        if (e.target.value === "horizontal") {
            SetModuleSize(sceneViewer.virModule.children[0], useViewerStore.getState().activeModule, "land", true);
        } else {
            SetModuleSize(sceneViewer.virModule.children[0], useViewerStore.getState().activeModule, "port", true);
        }

        useViewerStore.setState({activeBallastRackDirection: e.target.value});
    }


    useEffect(() => {
        if (selRoof.length > 0) {
            if (selRoof[0].userData.pitchOverride < 5.1 && !isGroundMount(selRoof[0])) {

                sceneViewer.viewerAlert({
                    title: 'Flat Roof Selected',
                    message: "Selected Roof has a pitch of less than 5 degrees, Ballasted Racking recommended",
                    messageType: "info",
                    isCloseAfterDisplay: true,
                    autoCloseSeconds: 3000,
                })

                setShowBallastRackAccordian(true);
            } else {
                setShowBallastRackAccordian(false);
            }
        }

    }, [selRoof]);



    return (
        <>
            <div className='tab__inner'>
               <ModuleEditOptionsSection/>
               <div className='tab__column'>
                <Accordion title='Show/Hide System Information' active={false}>
                    <div className='tab__column' style={{paddingTop: '0px', paddingLeft: '8px', paddingRight: '8px'}}>
                        <span className='tab__column--title' style={{marginBottom: '0px'}}>Total System Efficiency</span>
                        <TotalSystemEfficiency popoutVersion={false}/>
                        <span className='tab__column--title' style={{position: "relative", marginBottom: '2px'}}>Roof Information Table</span>
                        <RoofInformationTable shortened={true}/>
                    </div>
                </Accordion>
               </div>

                {(hasCapability('Edit_Module_Type') && doesDesignContainFlatRoof) &&
                    <div
                        className={`tab__column ${showBallastRackAccordian ? 'makeBallastedRackingAccordianVisible' : 'makeBallastedRackingAccordianHidden'}`}

                    >
                        <Accordion id={"ballastRackingAccordian"} title='Ballasted Racking' active={false}>
                            <Flex gap={10}>


                                <Button
                                    icon={<Plus size={18}/>}
                                    type='default'
                                    size='middle'
                                    className={`${isBallastedRackTypeModuleActive ? 'active' : ''}`}
                                    id='addBallastRackBtn'
                                    onClick={addBallastedRackModule}
                                >
                                    Add Rack
                                </Button>

                                <Button
                                    icon={<ArrowsCounterClockwise size={18}/>}
                                    type='default'
                                    size='middle'
                                    id='flipRackBtn'
                                    onClick={e => flipBallastTypeModule(sceneViewer)}
                                >
                                    Flip Rack
                                </Button>

                            </Flex>
                            <Divider/>
                            <span className='tab__column--title'>

                                <ArrowsOut/>
                                &nbsp;
                                Rack Direction</span>
                            <Radio.Group
                                options={rackingDirectionOptions}
                                defaultValue="horizontal"
                                value={activeBallastRackDirection}
                                optionType="button"
                                buttonStyle="solid"
                                onChange={(e) => setRackDirection(e)}
                            />

                            <Divider/>
                            <span className='tab__column--title'><Angle/>&nbsp;Ballast Racking Angle</span>
                            {
                                <Select
                                    placeholder='Select Racking Angle'
                                    style={{width: '100%'}}
                                    disabled
                                    value={"10"}
                                    showSearch={true}
                                    onChange={selectModule}
                                    options={rackingOptions}
                                />
                            }
                            <Divider/>

                            <Flex align={"center"}>
                        <span className='tab__column--title'>
                        <Flag/>
                            &nbsp;
                            25% Rule
                            &nbsp;
                            <Tooltip title="
                              The 25% rule is a guideline that states that the number of ballast modules should be at least 25% of the number of regular modules (total system size).If this is only a flat roof design (only racking), then the minimum number of ballast modules should be 5.
                              ">
                                  <Question size={20}/>
                                 </Tooltip>

                        </span>
                            </Flex>
                            {isBallastedRackingMeeting25percentRule ?
                                <Badge status="success" text="Meeting 25% Rule"/> :
                                <Badge status="error" text="Not Meeting 25% Rule"/>}
                            <p className='tab__column--subtitle' data-updateOn={isBallastedRackUpdated}>
                                Number of Pitched Regular Modules
                                Added: {sceneViewer.moduleMeshArr.filter((item: ModuleMesh) => !item.userData.isBallastedRackType).length}
                            </p>
                            <p className='tab__column--subtitle' data-updateOn={isBallastedRackUpdated}>
                                Number of Ballast Modules
                                Added: {sceneViewer.moduleMeshArr.filter((item: ModuleMesh) => item.userData.isBallastedRackType).length}
                            </p>
                            <p className='tab__column--subtitle' data-updateOn={isBallastedRackUpdated}>
                                25% Ballast
                                Modules: {calculate25PercentBallastModules()}
                            </p>
                            <p className='tab__column--subtitle' data-updateOn={isBallastedRackUpdated}>

                            </p>
                        </Accordion>


                    </div>
                }

                {hasCapability('Edit_Module_Type') &&
                    <>
                        <div className={`tab__column ${manualZone ? 'disabled' : ''}`}>
                            <span className='tab__column--title'>Module Type</span>
                            {
                                <Select
                                    placeholder='Select Module Type'
                                    style={{width: '100%', fontSize: '11px'}}
                                    value={activeModule?.text ?? ''}
                                    showSearch={true}
                                    onChange={selectModule}
                                    onFocus={() => {
                                        useViewerStore.setState({isTypeEvent: true});
                                    }}
                                    onBlur={() => {
                                        useViewerStore.setState({isTypeEvent: false});
                                    }}
                                    options={antdCompatiableModuleList}
                                />
                            }
                        </div>
                    </>
                }

                <div className={`tab__column`}>
                    <div className='btn-module'>
                        <div className='w-half'>
                            <Button
                                icon={<Ruler size={16}/>}
                                className='font-sm'
                                size='middle'
                                onClick={handleMoveModuleByMeasurement}>Measurement Move</Button>
                        </div>
                        <div className='w-half'>
                            <Button
                                icon={<BoundingBox size={18}/>}
                                className={`font-sm ${isBoxSelectMode ? 'active' : ''}`} size='middle'
                                onClick={setBoxSelectMode}
                            >Box Select Mode</Button>
                        </div>
                        <div className={`w-half ${selRoofFaceArr ? 'center' : ''}`}>
                            <Button
                                icon={<ArrowsClockwise size={18}/>}
                                className='font-sm'
                                id='spinAllModulesBtn' type='default' size='middle'
                                onClick={spinAllModules}
                            >Rotate All Panels</Button>
                        </div>
                            {selRoofFaceArr.map((item) => {
                                return(
                                    <>
                                        {hasCapability('Edit_Module_Remove') &&
                                            <div className='w-half'>
                                                <Button
                                                    icon={<Eraser size={18}/>}
                                                    className='font-sm'
                                                    type='default' size='middle'
                                                    onClick={() => clearModule(item)}>
                                                    Clear Roof Layout
                                                </Button>
                                            </div>
                                        }
                                        <div className='w-half'>
                                            <Button
                                                icon={<MdOutlineCropPortrait size={20}/>}
                                                size='middle'
                                                className='font-sm'
                                                onClick={() => autoFillHandler('port')}>
                                                    Autofill Portrait
                                            </Button>
                                        </div>
                                        <div className='w-half'>
                                            <Button
                                                icon={<MdOutlineCropLandscape size={20}/>}
                                                size='middle'
                                                className='font-sm'
                                                onClick={() => autoFillHandler('land')}>
                                                    Autofill Landscape
                                            </Button>
                                        </div>
                                        <div className='w-half'>
                                            <Button
                                                icon={<BsGrid1X2 size={18}/>}
                                                size='middle'
                                                className='font-sm'
                                                onClick={() => autoFillHandler('both')}>
                                                    Autofill Both
                                            </Button>
                                        </div>

                                        <div className='w-half'>
                                            <Button
                                                icon={<CheckCircle size={18}/>}
                                                size='middle'
                                                className='font-sm'
                                                onClick={deactivateRoofHandler}>
                                                {
                                                    selectedRoofStatus ? <span className={"deactive-roof-context-menu-enable-text"}>Activate Roof</span> : <span className={"deactive-roof-context-menu-disable-text"}>Deactivate Roof</span>
                                                }
                                            </Button>
                                        </div>
                                    </>
                        )})}
                    </div>
                </div>
                <div className='tab__column'>
                    <div className='tab__flex justify-between'>
                        <span className='tab__column--subtitle mb-0'>Module Solar Access</span>
                        <Toggle
                            id={"hideModuleTexture"}
                            on={moduleSolarAccess}
                            onChange={(value: boolean) => {
                                useViewerStore.setState({moduleSolarAccess: value});
                                SetDisplayShadePoints(sceneViewer, null);
                                toggleLayer(LAYER_OPTIONS.SYSTEM.IRRADIANCE, value)
                            }}
                            property='ModuleTexture'
                        ></Toggle>
                    </div>
                    <br/>
                    <div className='tab__flex justify-between'>
                        <span className='tab__column--subtitle mb-0'>Show/Hide Roof Tag</span>
                        <Toggle
                            on={isRoofTagVisible}
                            onChange={toggleRoofTag}
                        />
                    </div>
                    <br/>

                    {

                        user && (user.application_role_name == "Sales Ops" || user.application_role_name == "RSA" || user.application_role_name=="Admin") &&

                        <div className='tab__flex justify-between'>
                            <span className='tab__column--subtitle mb-0'>Enforce 33% Rule (Add On Only)</span>
                            <Toggle
                                on={isSetbackOverride}
                                onChange={toggleSetbackOverride}
                            />
                        </div>

                    }

                </div>

            </div>
        </>
    );
}

export default ModuleProperties;
